import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17bb2676"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wechatContacts" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "联系人", -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "群组", -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { ref, computed, onMounted } from "vue";
import { weChatAPI } from "@/api/weChat";
import { WeChatActions, WeChatGetters, WeChatMutations } from "@/store/modules/weChat";
import { WeChatSession } from "@/store/modules/weChat/types";
import WeChatSessionCard from "@/components/weChat/WeChatSessionCard.vue";
import WeChatSearch from '@/components/weChat/WeChatSearh.vue';


import { defineComponent } from "vue";

const __default__ = defineComponent({
    name: "WeChatContactWindow",
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const activeName = ref<string>('contact')
const route = useRoute();
const store = useStore();
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const wechatIdCom = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getMeId}`];
});
const isContactAllLoaded = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getIsContactAllLoaded}`];
});
const isContactLoading = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getIsContactLoading}`];
});
const contactList = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getWeChatContactList}`];
});
const isChatroomAllLoaded = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getIsChatroomAllLoaded}`];
});
const isChatroomLoading = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getIsChatroomLoading}`];
});
const chatroomList = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getWeChatChatroomList}`];
});
const selectedSession = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getSelectedSession}`];
});
const loadWeChatContact = () => {
    if (activeName.value === 'contact') {
        if (!isContactAllLoaded.value && !isContactLoading.value) {
            const projId = projectId.value;
            const uid = targetId.value;
            const wechatId = wechatIdCom.value;
            const isAppend = true;
            try {
                store.dispatch(`weChat/${WeChatActions.asyncGetContactListByUid}`, { projId, uid, wechatId, isAppend });
            } catch (err) {
                console.log(err);
            }
        }
    } else if (activeName.value === 'chatroom') {
        loadWeChatChatroom()
    }
}

const loadWeChatChatroom = () => {
    if (!isChatroomAllLoaded.value && !isChatroomLoading.value) {
        const projId = projectId.value;
        const uid = targetId.value;
        const wechatId = wechatIdCom.value;
        const isAppend = true;
        try {
            store.dispatch(`weChat/${WeChatActions.asyncGetChatroomListByUid}`, { projId, uid, wechatId, isAppend });
        } catch (err) {
            console.log(err);
        }
    }
}

const isSessionSelected = (strUsrName: string) => {
    if (!selectedSession.value) {
        return false;
    }
    return strUsrName === selectedSession.value.NickName;
}

const handleClick = (session: WeChatSession) => {
    store.commit(`weChat/${WeChatMutations.setSelectedSession}`, session);
}
const asyncGetWechatIdList = async (projid: string, uid: string) => {
    await store.dispatch(`weChat/${WeChatActions.asyncGetMeId}`, { projid, uid });
}
onMounted(() => {
    // activeName.value === undefined ? activeName.value = ['contact'] : activeName.value.push('contact')
    let projid = projectId.value
    let uid = targetId.value
    try {
        asyncGetWechatIdList(projid, uid)
        if (wechatIdCom.value !== '') {
            loadWeChatContact()
            loadWeChatChatroom()
        }
    } catch (err) {
        console.log(err);
    }

});



return (_ctx: any,_cache: any) => {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_collapse, {
      modelValue: activeName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
      accordion: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { name: "contact" }, {
          title: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactList), (contact) => {
              return (_openBlock(), _createElementBlock("div", {
                key: contact.NickName
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass({ 'weChatConv': true, 'weChatConvActive': isSessionSelected(contact.NickName) }),
                  onClick: ($event: any) => (handleClick(contact))
                }, [
                  _createElementVNode("div", null, [
                    _createVNode(WeChatSessionCard, {
                      msgSender: contact.NickName,
                      msgContent: contact.NickName,
                      target: ''
                    }, null, 8, ["msgSender", "msgContent"])
                  ])
                ], 10, _hoisted_3)
              ]))
            }), 128)),
            (_unref(isContactLoading))
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, "加载中......"))
              : _createCommentVNode("", true),
            (_unref(isContactAllLoaded))
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, "------已加载全部-------"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_collapse_item, { name: "chatroom" }, {
          title: _withCtx(() => [
            _hoisted_6
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chatroomList), (chatroom) => {
              return (_openBlock(), _createElementBlock("div", {
                key: chatroom.NickName
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass({ 'weChatConv': true, 'weChatConvActive': isSessionSelected(chatroom.NickName) }),
                  onClick: ($event: any) => (handleClick(chatroom))
                }, [
                  _createElementVNode("div", null, [
                    _createVNode(WeChatSessionCard, {
                      msgSender: chatroom.NickName,
                      msgContent: chatroom.NickName,
                      target: ''
                    }, null, 8, ["msgSender", "msgContent"])
                  ])
                ], 10, _hoisted_7)
              ]))
            }), 128)),
            (_unref(isContactLoading))
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, "加载中......"))
              : _createCommentVNode("", true),
            (_unref(isContactAllLoaded))
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, "------已加载全部-------"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [_directive_infinite_scroll, loadWeChatContact]
  ])
}
}

})